import React, { Fragment } from 'react'

import Page from '../page'

import { translate } from '../helpers/stringTranslation'
import SEO from '../components/seo'
import ArticleArchiveComponent from '../components/post/archive'

class ArticleArchivePost extends Page {
  onMountGlobalState(state) {
    return {
      ...state,
      whiteLogo: false,
      headerWidget: 'articleFilterSort',
    }
  }

  render() {
    return (
      <Fragment>
        <SEO
          title={translate('articles')}
          {...this.props.pathContext}
          key="seo"
        />
        <ArticleArchiveComponent data={this.props.data} />
      </Fragment>
    )
  }
}

export default ArticleArchivePost

export const pageQuery = graphql`
  query ArticlesQuery($lang: String!) {
    articles: allWordpressPost(filter: { lang: { eq: $lang } }) {
      edges {
        node {
          ...PostExcerptFragment
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog-archive.js